import { randomNum } from '@/utils'

export default {
  namespaced: true,
  state: {
    currentTab: '',
    list: []
  },
  mutations: {
    open (state, payload) {
      let flag = state.list.find(item => {
        if (item.name === payload.name) {
          item.params = payload.params
          return true
        } else {
          return false
        }
      })
      if (flag) {
        state.currentTab = payload.name
      }
    },
    new (state, payload) {
      state.list.push(payload)
      state.currentTab = payload.name
    },
    remove (state, tabName) {
      state.list = state.list.filter(item => item.name !== tabName)
      if (tabName === state.currentTab) {
        if (state.list && state.list.length > 0) {
          state.currentTab = state.list[state.list.length - 1].name
        }
      }
    },
    updateCurrent (state, tabName) {
      state.currentTab = tabName
    },
    removeAll (state) {
      state.currentTab = ''
      state.list = []
    }
  },
  getters: {
    isOpened (state) {
      return tabName => state.list.find(item => item.name === tabName)
    }
  },
  actions: {
    open (context, payload) {
      const isOpened = context.getters['isOpened'](payload.name)
      const itemName = payload.name.split('@')[0]
      const menuItem = context.rootGetters['menu/getItem'](itemName)
      if (!menuItem) {
        return
      }
      if (!isOpened || menuItem.isMulti) {
        // 如果该tab不存在或支持多开，新建并打开
        let name = menuItem.key
        if (menuItem.isMulti) {
          name += '@' + randomNum()
        }
        context.commit('new', {
          title: menuItem.title,
          component: menuItem.component,
          name,
          params: payload.params
        })
      } else {
        // 如果该tab已存在，不支持多开，直接打开
        context.commit('open', payload)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tabs/index.js